<app-menu-item
  [icon]="icon"
  [label]="label"
  [reason]="reason"
  [disabled]="disabled"
  (selected)="onClick()"
></app-menu-item>
